import { QUESTION_TYPE } from '../../../../constants/questionTypes';
import type { FileUploadQuestion } from '../../../../types/index';
import type { ApiQuestion } from '../../../../internalTypes';
import type { ResolvedQuestionShell } from '../shared/resolveQuestionShell';

export function mapFileUploadQuestion(
  raw: ApiQuestion,
  shell: ResolvedQuestionShell,
  language?: string
): FileUploadQuestion {
  const configs = raw.questionConfigs || [];

  const uploadMessageDetail = raw.answerDetails?.find(
    a => a.additional?.fieldType === 'UPLOAD_MESSAGE'
  );
  const uploadMessage =
    (language && uploadMessageDetail?.translations?.[language]?.answerText) ||
    uploadMessageDetail?.answerText ||
    '';

  const supportedConfig = configs.find(c => c.key === 'SUPPORTED_FILE_FORMAT');
  const supportedFileFormats =
    supportedConfig?.value?.map(ext => ext.toUpperCase().replace(/^\./, '')) || [];

  const maxFileCountConfig = configs.find(c => c.key === 'MAX_FILE_COUNT');
  const maxFileCount = maxFileCountConfig?.value?.[0]
    ? Number(maxFileCountConfig.value[0])
    : undefined;

  const fileSizeLimitConfig = configs.find(c => c.key === 'FILE_SIZE_LIMIT');
  const sizeLimitId = fileSizeLimitConfig?.childConfigs?.find(
    cc => cc.key === 'SIZE_LIMIT_ID'
  )?.value?.[0];
  const sizeFormatId = fileSizeLimitConfig?.childConfigs?.find(
    cc => cc.key === 'SIZE_FORMAT_ID'
  )?.value?.[0];

  const fileSizeLimit = sizeLimitId ? Number(sizeLimitId) : undefined;
  const fileSizeLimitType: 'PER_FILE' | 'IN_TOTAL' =
    sizeFormatId === 'IN_TOTAL' ? 'IN_TOTAL' : 'PER_FILE';

  return {
    ...shell,
    type: QUESTION_TYPE.FILE_UPLOAD,
    supportedFileFormats,
    fileSizeLimitType,
    ...(uploadMessage ? { uploadMessage } : {}),
    ...(maxFileCount !== undefined ? { maxFileCount } : {}),
    ...(fileSizeLimit !== undefined ? { fileSizeLimit } : {}),
  };
}
